var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zingchart',{attrs:{"height":_vm.height,"width":_vm.width,"data":_vm.graph_settings,"series":_vm.graph_series}})}
var staticRenderFns = []

export { render, staticRenderFns }